<!-- 活动 -->
<template>
  <div class="sponsor">
    <v-head></v-head>
    <div class="container" style="min-width:1200px;">
      <!-- banner -->
      <div class="sponsor-banner">
        <el-carousel trigger="click" :interval="5000" arrow="never" height="100%">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <div class="banner-img" :style="'background-image:url(' + item.image_url + ')'"></div>
            <!-- <div class="help-banner-zz"></div> -->
            <div class="sponsor-banner-con">
              <div class="sponsor-banner-title">{{ item.title }}</div>
              <div class="sponsor-banner-line">—</div>
              <div class="sponsor-banner-message">{{ item.description }}</div>
              <div class="sponsor-banner-more">
                <a href="javascript:void(0);">
                  <el-button size="small">
                    {{ item.button_name }}
                    <i class="el-icon-arrow-right"></i>
                  </el-button>
                </a>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 活动展示 -->
      <div class="sponsor-activity">
        <!-- 活动切换nav -->
        <el-tabs class="sponsor-activity-nav" v-model="activityed" type="border-card">
          <el-tab-pane
            v-for="(item,index) of activityList"
            :key="index"
            :label="item.label"
            :name="item.label"
          >
            <div class="sponsor-activity-con">
              <div class="activity-con-title">{{ item.label }}</div>
              <div class="activity-con-message">{{ item.message }}</div>
              <div class="activity-con-cut">
                <div
                  class="activity-cut-prev"
                  :class="activityed === activityList[0].label?'activity-disabled':''"
                  @click="prev()"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div
                  class="activity-cut-next"
                  :class="activityed === activityList[activityList.length-1].label?'activity-disabled':''"
                  @click="next()"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 活动案例 -->
      <div class="sponsor-case" id="activity-case">
        <div class="case-title">
          <span class="case-title-t">活动案例</span>
          <span class="case-title-b">做为企业进入校园市场的重要载体</span>
        </div>
        <div class="case-main">
          <div class="case-search">
            <div class="case-search-box">
              <el-input
                placeholder="请输入活动名称搜索"
                v-model="searchModel"
                size="small"
                class="input-with-select"
                @keyup.enter.native="tipswords()"
              ></el-input>
              <i class="el-icon-search" @click="tipswords()"></i>
            </div>
          </div>
          <div class="case-list">
            <div
              class="case-item"
              v-for="(item,index) of caseList"
              :key="index"
              @click="toSponsorDetailes(item.caseId,item.title)"
            >
              <div class="case-conBackground">
                <div
                  class="case-conBackground-img"
                  :style="'backgroundImage:url(' + item.img + ')'"
                ></div>
                <div class="case-conTitle">{{item.title}}</div>
                <!-- 活动状态 -->
                <span class="case-item-type" v-if="item.status == 1">进行中</span>
                <span class="case-item-typeed" v-else-if="item.status == 2">已完结</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 关联企业 -->
      <!-- <v-relation style="background-color:#ffffff;"></v-relation> -->
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import bg from '@/assets/img/bg-zz.png'
import vRelation from '@/components/relation/relation.vue'
import {
  Carousel,
  CarouselItem,
  Button,
  Tabs,
  TabPane,
  Input
} from 'element-ui'
// import Swiper from 'swiper'
export default {
  data () {
    return {
      img: bg, // 临时图片
      activityed: '官方背书',
      activityList: [{
        label: '官方背书',
        message: '符合条件的活动，可申请获得团中央或各级指导部门活动批涵，下发或通知各高校，以提高活动规格与公信力，同时得到高校资源倾斜与助力。'
      }, {
        label: '二课金课',
        message: '符合第二课堂育人要求的活动，可申请录入全国第二课堂精品活动库（二课金课），入库活动作为第二课堂标准活动向全国高校推广，拥有官方背书，学生参与后可获得准成长记录，学校根据相应规则赋予第二课堂学分。'
      }, {
        label: '全校园媒体矩阵',
        message: '团中央官方媒体、教育部官方媒体、各级指导部门媒体、到梦空间平台、高校各级媒体、学生社团媒体、学生自媒体等共同组成媒体矩阵。'
      }, {
        label: '兴趣社群',
        message: '打造覆盖全国的线上线下成长社群，与他人建立连接，共同探索与体验兴趣世界。覆盖1500所高校、34个省市建学生社群，带领几百万青年参与成长兴趣部落。'
      }],
      bannerList: [{
        button_name: '了解更多',
        description: '全国第二课堂精品活动库（二课金课），依托全国学校共青团优秀研究成果评选机制，通过校级专家轮值评审委员会，将符合第二课堂育人初衷，有效培养学生能力、有效整合社会资源的优秀活动收录、评定并向全国高校推广推荐。',
        id: 29,
        image_url: 'https://sponsorentpic.nauac.com/20200506/f9913d3b720e4139bdfca639e3f9cd98.jpg',
        title: '第二课堂精品活动库',
        url: 'https://sponsorentpic.nauac.com/20200506/f9913d3b720e4139bdfca639e3f9cd98.jpg'
      }],
      caseList: [],
      searchModel: '',
      prevClick: true,
      nextClick: true
    }
  },
  watch: {
    searchModel (val) {
      if (val === '') {
        this.init()
      }
    }
  },
  components: {
    'el-carousel': Carousel,
    'el-carousel-item': CarouselItem,
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'v-relation': vRelation,
    'el-input': Input
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init (title) {
      let newTit = ''
      if (title) {
        newTit = title
      } else {
        newTit = ''
      }
      this.$http({
        method: 'post',
        url: '/sponsor_case/list',
        params: {
          title: newTit
        }
      }).then(res => {
        if (res.code === 100) {
          this.caseList = res.result
        } else {
          this.$message.info(res.result.msg || res.msg)
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    prev () {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === 0) {
            return
          } else {
            this.activityed = this.activityList[i - 1].label
            return
          }
        }
      }
    },
    next (e) {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === (this.activityList.length - 1)) {
            return
          } else {
            this.activityed = this.activityList[i + 1].label
            return
          }
        }
      }
    },
    // 模糊搜索
    tipswords () {
      this.init(this.searchModel)
    },
    toSponsorDetailes (id, title) {
      this.$router.push({
        path: '/activitydetail',
        query: {
          id: id,
          title: title
        }
      })
    }
  }
}
</script>
<style lang="css" scope>
.sponsor {
  width: 100%;
}
@media screen and (max-width: 1201px) {
  .case-main {
    width: 1100px !important;
    max-width: 1100px !important;
  }
}
</style>
<style src='./activity_active.scss' lang="scss"></style>
<style src='./activity.scss' lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/activity/activity.vue